import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import Header from '../../../components/Header/index'
import Empty from '../../../components/Empty/Empty'
import NotificationItem from './NotificationItem'
import IconButton from '../../../components/IconButton'
import EyeGreenSvg from '../../../assets/icons/EyeGreenSvg'
import { persistSelectedGarden, resolveSelectedGarden } from '../services/selectedGardenStorage'

import './NotificationPage.css'

const NotificationPage = () => {
  let location = useLocation()
  const navigate = useNavigate()
  const notificationData = location?.state?.notificationData ?? []
  const selectedTesis = resolveSelectedGarden(location?.state?.selectedTesis)
  const hasNotifications = notificationData.length > 0

  const handleBackButton = () => {
    if (selectedTesis) {
      persistSelectedGarden(selectedTesis)
    }

    navigate('/hobiHome', {
      state: {
        selectedTesis: selectedTesis,
      },
    })
  }

  return (
    <>
      <div
        className='scrollDiv'
        style={{
          padding: '0 0 2rem 0',
        }}
      >
        <div
          style={{
            backgroundColor: '#fff',
            position: 'sticky',
            top: 0,
            zIndex: 999,
          }}
        >
          <Header backButton onClick={handleBackButton} rules={true} />
        </div>
        <div className='underlineTitle' style={{ margin: '1rem 0 .2rem 0' }}>
          {'Tesis Duyuruları'}
        </div>
        <div style={{ padding: '1.7rem 0 0 0', width: '100%' }}>
          {!hasNotifications ? (
            <Empty text='Bu tesis için henüz duyuru bulunmamaktadır.' />
          ) : (
            notificationData.map((item, index) => (
              <div
                key={item.id}
                style={{
                  padding: '1rem',
                  backgroundColor: index % 2 ? '#fff' : '#f5f5f5',
                }}
              >
                <NotificationItem
                  title={item.baslik}
                  date={item.created_at}
                  desc={item.aciklama}
                  adds={item.dosya}
                  detay={false}
                  dividerVisible={false}
                />
                <IconButton
                  widthHalf={false}
                  padding={false}
                  backgroundColor={'transparent'}
                  color='#205c42'
                  border={'1px solid #205c42'}
                  icon={<EyeGreenSvg width={18} height={18} />}
                  text={'Devamını Oku'}
                  onClick={() => {
                    navigate('/hobiNotificationDetail', {
                      state: {
                        item: item,
                        notificationData: notificationData,
                        selectedTesis: selectedTesis,
                      },
                    })
                  }}
                />
              </div>
            ))
          )}
        </div>
      </div>
    </>
  )
}

export default NotificationPage
